import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import AirportDetailOptionsPanel from "./AirportDetailOptionsPanel";
import { AirportDetailSection } from "airport/AirportDetailSection";
import { useLoaderData } from "react-router";

const AirportDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.AirportDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <AirportDetailSection
        airport={viewModel.airport}
      />
    </TwoColumnLayout.LeftColumn>
    <TwoColumnLayout.RightColumn>
      <AirportDetailOptionsPanel
        optionsPanelData={viewModel.optionsPanel}
        listUrl={viewModel.listUrl}
      />
    </TwoColumnLayout.RightColumn>
  </TwoColumnLayout>
}

export default AirportDetailApp;